import { OrderStatusEnum } from '../models';

export const orderStatus: { [key in OrderStatusEnum]: OrderStatusEnum } = {
  initial: 'initial',
  confirmed: 'confirmed',
  complete: 'complete',
  cancelled: 'cancelled',
  receivable: 'receivable',
  refunded: 'refunded',
};

export const orderStatusTranslate = {
  initial: 'Inicial',
  confirmed: 'Confirmado',
  complete: 'Completado',
  cancelled: 'Cancelado',
  receivable: 'En revisión',
  refunded: 'Reembolsado',
};

export const orderPaymentStatusTranslate = {
  paid: 'Pagado',
  pending: 'Pendiente',
  failed: 'Falla',
  cancelled: 'Cancelado',
  refunded: 'Reembolsado',
  approved: 'Aprobado',
  rejected: 'Rechazado',
};
